/*@ngInject*/
const DropdownController = function ($scope, $element, localization, dropdownMediator, coreConstant) {

    this.$onInit = function () {
        this.selectedOption = this.selectedOption || {};
        this.searchTerm = this.searchTerm || '';
        this.placeholder = this.placeholder || '';
        this.required = this.required === true || this.required === 'true' || false;

        localization.setupLocale('component', require('./dropdown.i18n.json'));

        this.uniqueComponentClass = this.className + 'DropdownComponent';

        $element.addClass('umDropdownContainer');
        $element.addClass(this.uniqueComponentClass);

        this.feedbackMessage = '';
        this.noMatchesError = i18n.t('component|dropdown.noMatchesFoundMessage');
    };

    this.$onChanges = function (changes) {
        const dropdownSelectedValueState = dropdownMediator.getDropdownSelectedValueState(changes, this.selectedOption, this.optionList, this.placeholder);

        if (!_.isNil(dropdownSelectedValueState)) {
            this.selectedOption = dropdownSelectedValueState.selectedOption;
            this.dropdownButtonDisplayText = dropdownSelectedValueState.dropdownButtonDisplayText;
        }

        this.filterOptionList();
        this.validateOptionList();
    };

    this.onSelectedOptionChange = function (option) {
        this.selectedOption = option;
        this.toggleOptionList({originalEvent: {repeat: false}});
        this.onChange({selectedOption: this.selectedOption});
    };

    this.toggleOptionList = function (event) {
        if (!event.originalEvent.repeat) {
            this.isOptionListOpen = !this.isOptionListOpen;

            if (!this.isOptionListOpen) {
                $scope.setFocus('.' + this.uniqueComponentClass + ' .umDropdownButton button', event);
                this.onClose();
            }

            this.filterOptionList();
            this.validateOptionList();
        }
    };

    this.isDropdownListVisible = function () {
        return this.feedbackMessage === null;
    };

    this.onSearch = function (searchTerm) {
        this.searchTerm = searchTerm;
        this.filterOptionList();
        this.validateOptionList();
    };

    this.filterOptionList = function () {

        this.filteredOptionList = _.filter(this.optionList, (option) => {
            const searchTerm = this.searchTerm || '';
            const isSearching = !_.isEmpty(this.searchTerm);
            const optionValue = _.get(option, 'value') || '';
            const optionName = _.get(option, 'name') || '';
            const isWithinSearchBounds = _.includes(optionValue.toLowerCase(), searchTerm.toLowerCase()) || _.includes(optionName.toLowerCase(), searchTerm.toLowerCase());

            return isSearching ? isWithinSearchBounds : true;
        });
    };

    this.validateOptionList = function () {
        if (!_.isNil(this.filteredOptionList)) {
            const numberOfOptions = _.get(this.filteredOptionList, 'length');
            const hasZeroOptions = numberOfOptions === 0;

            if (hasZeroOptions) {
                this.feedbackMessage = this.noMatchesError;
            } else {
                this.feedbackMessage = null;
            }
        }
    };

    this.isClearButtonEnabled = function () {
        return !_.isEmpty(this.selectedOption.name);
    };

    this.onClearSelectedOption = function () {
        this.selectedOption = {};
        this.toggleOptionList({originalEvent: {repeat: false}});
        this.onChange({selectedOption: null});
    };

    $scope.$on(coreConstant.event.dropdown.DROPDOWN_CLEAR_SELECTED, () => {
        if (this.isOptionListOpen) {
            this.onClearSelectedOption();
        }
    });

    $scope.$on(coreConstant.event.dropdown.DROPDOWN_CLOSE, (event) => {
        if (this.isOptionListOpen) {
            this.toggleOptionList({originalEvent: {repeat: false}})
        }
    });
};

angular.module('umCore')
    .controller('umDropdownController', DropdownController);

module.exports = DropdownController;
